import axiosInstance from 'services/axiosInstance';
import { IResponse } from 'services/types';
import { IUser, IMyTimezoneProfile, IPsaSyncLastRun } from 'services/user/types';

export const getUser = (id: number): IResponse<IUser> =>
  axiosInstance.request({
    url: `User/${id}`,
    method: 'GET',
  });

/**
 * Returns the calling user's MSPP timezone plus per-PSA timezone snapshots
 * (with the offset-based `hasMismatch` flag the backend computes). Used by the
 * Pod to warn a tech, when they copy or send a booking link, that the times
 * posted to a PSA calendar will differ from their MSPP timezone.
 */
export const getMyTimezoneProfile = (): IResponse<IMyTimezoneProfile> =>
  axiosInstance.request({
    url: 'User/me',
    method: 'GET',
    // @ts-expect-error — custom flag honoured by the global response interceptor.
    skipErrorSnackbar: true,
  });

/**
 * Enqueues a live re-sync of the calling user's own account against `provider`
 * (a `CrmTypes` value). This is the self-service equivalent of the Users-page
 * "Refresh" button — it pulls the latest name/email/timezone from the PSA. The
 * sync runs as a background job; poll {@link getPsaSyncLastRun} for completion
 * before re-reading {@link getMyTimezoneProfile}.
 */
export const refreshMyPsaSnapshot = (provider: number): IResponse<{ jobIds: number[] }> =>
  axiosInstance.request({
    url: `CrmUsers/My/SyncFromPsa?provider=${provider}`,
    method: 'POST',
    // @ts-expect-error — custom flag honoured by the global response interceptor.
    skipErrorSnackbar: true,
  });

/** Per-PSA last sync-job state, used to detect when an enqueued refresh has finished. */
export const getPsaSyncLastRun = (): IResponse<IPsaSyncLastRun[]> =>
  axiosInstance.request({
    url: 'CrmUsers/PsaSyncLastRun',
    method: 'GET',
    // @ts-expect-error — custom flag honoured by the global response interceptor.
    skipErrorSnackbar: true,
  });
